import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useRevalidator } from "react-router-dom";

import ApiRequestErrorHandler from "../../../../../../components/global/ApiRequestErrorHandler";
import Modal from "../../../../../../components/global/Modal";
import ResponseModal from "../../../../../../components/global/ResponseModal";
import { isFormComplete } from "../../../../../../components/ui library/helpers/functions";
import useService from "../../../../../../hooks/useService";

export default function AddExpense({
  activeExpense,
  deductionOpts,
  open,
  setActiveExpense,
  setOpen,
}) {
  const additionalExpenseRepository = useService("repositories/additional-expense-repository");
  const { id: caseId } = useParams();
  const { revalidate } = useRevalidator();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    amount: "",
    label: "",
    deductionType: 3,
  });
  const allowSave = isFormComplete(formData, ["amount"]);

  const handleClose = () => {
    setOpen(false);
    setActiveExpense(null);
    setFormData({ amount: "", label: "", deductionType: 3 });
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
    setActiveExpense(null);
    setFormData({ amount: "", label: "", deductionType: 3 });
  };

  const handleRequest = async () => {
    setLoading(true);

    const body = {
      label: formData.label,
      amount: +formData.amount,
      deductionType: +formData.deductionType,
    };

    try {
      if (activeExpense) {
        await additionalExpenseRepository.patch(activeExpense.id, body);
      } else {
        await additionalExpenseRepository.createRecord({
          ...body,
          case: caseId,
        });
      }

      setLoading(false);
      setOpenSuccess(true);
      revalidate();
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpenError(true);
      const errArr = ApiRequestErrorHandler(error ?? []);
      setErrorArray(errArr);
    }
  };

  useEffect(() => {
    if (!activeExpense) {
      return;
    } else {
      setFormData(activeExpense);
    }
  }, [open, activeExpense]);

  return (
    <>
      <Modal
        open={open}
        title={!activeExpense ? "Add Expense" : "Edit Expense"}
        maxWidth="xs"
        onClose={handleClose}
        actions={[
          {
            disabled: !allowSave,
            isLoading: loading,
            onClick: handleRequest,
            label: "Submit Expense",
            className:
              "bg-blue-600 text-white hover:bg-blue-700 disabled:text-white disabled:bg-blue-400",
          },
        ]}
      >
        <div className="flex flex-col pt-6">
          <TextField
            className="mb-6 w-full"
            id="outlined-select"
            label="Deduction Type"
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                deductionType: e.target.value,
              }));
            }}
            required
            select
            size="small"
            value={formData.deductionType}
          >
            {deductionOpts.map((option) => (
              <MenuItem value={option.value} key={option.value}>
                {option.display_name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            required
            className="mb-6 w-full"
            id="outlined"
            label="Expense Label"
            onChange={(e) => setFormData((prev) => ({ ...prev, label: e.target.value }))}
            size="small"
            value={formData.label}
          />

          <TextField
            className="w-full"
            id="outlined-start-adornment"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            label="Expense Amount"
            onChange={(e) => setFormData((prev) => ({ ...prev, amount: e.target.value }))}
            size="small"
            type="number"
            value={formData.amount}
          />
        </div>
      </Modal>
      <ResponseModal
        title={`Expense ${activeExpense ? "Edition" : "Addition"} Successful`}
        description={`Case expense has been ${activeExpense ? "edited" : "added"}`}
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
        handleCloseFunc={handleCloseSuccess}
      />
      <ResponseModal
        title="Expense Add Failed"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  );
}
